module.exports = __webpack_public_path__ + "img/f08951d.jpg";